import $ from 'jquery';
import slick from 'slick-carousel';
import arrows from './sliders/arrows';

var updateArrowState = (slider, slick) => {
  var $prev = slider.find('.slick-prev');
  var $next = slider.find('.slick-next');

  var isFirst = slick.currentSlide === 0;
  var isLast =
    slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;

  $prev.prop('disabled', isFirst);
  $next.prop('disabled', isLast);
};

var clearActiveSlideTabIndexes = (slider) => {
  slider.find('.slick-active a').removeAttr('tabindex');
};

var clearActiveSlideTabIndexesAfterSlick = (slider) => {
  setTimeout(function () {
    clearActiveSlideTabIndexes(slider);
  }, 0);
};

function featuredCarousel() {

  var slider = $('.js-featuredCarousel');

  slider.on('init', function (event, slick) {
    updateArrowState($(this), slick);
    clearActiveSlideTabIndexesAfterSlick($(this));
  });

  slider.on('afterChange', function (event, slick) {
    updateArrowState($(this), slick);
    clearActiveSlideTabIndexesAfterSlick($(this));
  });

  slider.slick({
    ...arrows,
    dots: false,
    slidesToShow: 3,
    rows: 0,
    infinite: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2
        }
      },
    ]
  });

}

export default featuredCarousel;
